import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import './styles.css'

const NoTokenLocationSelected: React.FC = () => {
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Body>
        <ReactBootstrap.Card.Title>
          Please Provide Token Machine Information
        </ReactBootstrap.Card.Title>
        <ReactBootstrap.Card.Text>
          <strong>Please select the token machine location as required.</strong>
          <br />
          Contact your system administrator for more information.
        </ReactBootstrap.Card.Text>
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}

export default NoTokenLocationSelected
